import { PaneArea } from '../../../types/shared'
import { IScaledLineAttrs } from '../../canvas/scaled_line'
import VerticalLine from '../../canvas/vertical_line'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IScaledLineAttrs
type PartialAttrs = Partial<Attrs>

class VerticalLineCreator extends VerticalLine<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = startArea.x
    this.attrs.x2 = startArea.x

    setTimeout(() => {
      this.replaceMyself(VerticalLine.fromObject<VerticalLine>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default VerticalLineCreator
